import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/lang";
import { getConsent, setConsent, initAnalytics } from "../lib/analytics";

export const openCookieSettings = () => window.dispatchEvent(new Event("open-cookie-settings"));

const btn = "rounded-full border-2 border-ink px-4 py-3 font-display text-sm font-extrabold";

export const ConsentBanner = () => {
  const { t } = useLang();
  const c = t.cookie;
  const [open, setOpen] = useState(false);
  const [prefs, setPrefs] = useState(false);
  const [sel, setSel] = useState({ analytics: false, marketing: false });

  useEffect(() => {
    const saved = getConsent();
    if (saved) { setSel({ analytics: !!saved.analytics, marketing: !!saved.marketing }); initAnalytics(); }
    else setOpen(true);
    const reopen = () => { setOpen(true); setPrefs(true); };
    window.addEventListener("open-cookie-settings", reopen);
    return () => window.removeEventListener("open-cookie-settings", reopen);
  }, []);

  const save = (v) => {
    const prev = getConsent();
    setConsent(v);
    setSel(v);
    setOpen(false);
    const revoked = prev && ((prev.analytics && !v.analytics) || (prev.marketing && !v.marketing));
    if (revoked) window.location.reload();
    else initAnalytics();
  };

  if (!open) return null;
  return (
    <div role="dialog" aria-modal="false" aria-labelledby="cookie-title" className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-2xl rounded-2xl border border-ink/15 bg-white p-5 shadow-2xl sm:p-6" data-testid="cookie-banner">
      <p id="cookie-title" className="font-display text-base font-extrabold text-ink">{c.title}</p>
      <p className="mt-2 text-sm leading-relaxed text-night">{c.text} <Link to="/cookies" className="font-semibold text-ink underline">{c.policy}</Link></p>
      {prefs && (
        <div className="mt-4 space-y-3 rounded-xl bg-mist p-4 text-sm text-night" data-testid="cookie-preferences">
          <label className="flex items-center gap-3"><input type="checkbox" checked disabled className="h-5 w-5" />{c.essential}</label>
          <label className="flex items-center gap-3"><input type="checkbox" checked={sel.analytics} onChange={(e) => setSel((s) => ({ ...s, analytics: e.target.checked }))} className="h-5 w-5 accent-[#1E2B6B]" data-testid="cookie-analytics-toggle" />{c.analytics}</label>
          <label className="flex items-center gap-3"><input type="checkbox" checked={sel.marketing} onChange={(e) => setSel((s) => ({ ...s, marketing: e.target.checked }))} className="h-5 w-5 accent-[#1E2B6B]" data-testid="cookie-marketing-toggle" />{c.marketing}</label>
        </div>
      )}
      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
        <button onClick={() => save({ analytics: false, marketing: false })} className={`${btn} text-ink hover:bg-sky`} data-testid="cookie-reject-button">{c.reject}</button>
        {prefs ? (
          <button onClick={() => save(sel)} className={`${btn} text-ink hover:bg-sky`} data-testid="cookie-save-button">{c.save}</button>
        ) : (
          <button onClick={() => setPrefs(true)} className={`${btn} text-ink hover:bg-sky`} data-testid="cookie-preferences-button">{c.prefs}</button>
        )}
        <button onClick={() => save({ analytics: true, marketing: true })} className={`${btn} text-ink hover:bg-sky`} data-testid="cookie-accept-button">{c.accept}</button>
      </div>
    </div>
  );
};
